import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// import { createStaff } from "../../../../../services/api";
import { adminApi } from "../../../../../services/index";

export default function CreateStaff() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    role: "staff",
    isActive: true,
    permissions: {
      canCredit: false,
      canDebit: false,
      canCreateUser: false,
      canViewReports: false,
    },
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name in formData.permissions) {
      setFormData((prev) => ({
        ...prev,
        permissions: { ...prev.permissions, [name]: checked },
      }));
    } else {
      const val = type === "checkbox" ? checked : (name === "isActive" ? value === "true" : value);
      setFormData((prev) => ({ ...prev, [name]: val }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Sending formData directly as it is now a clean JSON object
      await adminApi.createStaff(formData);
      alert("Staff created successfully!");
      navigate("/admin-dashboard/staffs");
    } catch (err) {
      const errorMsg = err.response?.data?.message || err.response?.data?.error || "Error connecting to server";
      alert(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Create Staff</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          className="form-control mb-2"
          name="name"
          placeholder="Full Name"
          autoComplete="off"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <input
          type="email"
          className="form-control mb-2"
          name="email"
          placeholder="Email Address"
          autoComplete="off"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <input
          type="tel"
          className="form-control mb-2"
          name="phone"
          placeholder="Phone Number"
          autoComplete="off"
          value={formData.phone}
          onChange={handleChange}
          required
        />

        <input
          type="password"
          className="form-control mb-2"
          name="password"
          placeholder="Password"
          autoComplete="off"
          value={formData.password}
          onChange={handleChange}
          required
        />

        <div className="row mb-2">
          <div className="col">
            <select name="role" className="form-control" value={formData.role} onChange={handleChange}>
              <option value="staff">Role: Staff</option>
              <option value="admin">Role: Admin</option>
            </select>
          </div>
          <div className="col">
            <select name="isActive" className="form-control" value={formData.isActive} onChange={handleChange}>
              <option value={true}>Status: Active</option>
              <option value={false}>Status: Inactive</option>
            </select>
          </div>
        </div>

        <fieldset className="mb-3 p-3 border rounded">
          <legend className="float-none w-auto px-2 small text-muted">Permissions</legend>
          <div className="d-flex flex-wrap gap-4">
            {Object.keys(formData.permissions).map((perm) => (
              <div className="form-check" key={perm}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  name={perm}
                  id={perm}
                  checked={formData.permissions[perm]}
                  onChange={handleChange}
                />
                <label className="form-check-label text-capitalize" htmlFor={perm}>
                  {perm.replace(/([A-Z])/g, ' $1').trim()}
                </label>
              </div>
            ))}
          </div>
        </fieldset>

        <button type="submit" className="btn btn-primary w-100 py-2" disabled={loading}>
          {loading ? "Processing..." : "Create Staff Account"}
        </button>
      </form>
    </div>
  );
}
